import axios, { AxiosRequestConfig } from 'axios';

const axiosServices = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

export const axiosDefault = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

export default axiosServices;

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosServices.get(url, { ...config });

  return res.data;
};

export const fetcherPost = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosServices.post(url, { ...config });

  return res.data;
};
